import React from 'react'

const Lock = ({ color }) => {
  return (
    <svg
      width="17px"
      height="22px"
      viewBox="0 0 17 22"
      version="1.1"
      // xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="desktop-lock"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="desktop-lock-one" fill={color} fillRule="nonzero">
          <path
            d="M5.39423077,9.46236559 C5.39423077,10.2462536 4.73557276,10.8817204 3.92307692,10.8817204 C3.11058109,10.8817204 2.45192308,10.2462536 2.45192308,9.46236559 L2.45192308,6.09796894 C2.45192308,2.97554254 5.17536018,0.47311828 8.5,0.47311828 C11.8246398,0.47311828 14.5480769,2.97554254 14.5480769,6.09796894 L14.5480769,9.46236559 C14.5480769,10.2462536 13.8894189,10.8817204 13.0769231,10.8817204 C12.2644272,10.8817204 11.6057692,10.2462536 11.6057692,9.46236559 L11.6057692,6.09796894 C11.6057692,4.57513292 10.2308898,3.31182796 8.5,3.31182796 C6.76911018,3.31182796 5.39423077,4.57513292 5.39423077,6.09796894 L5.39423077,9.46236559 Z"
            id="Shape"
          />
          <path
            d="M0.995328,8.04301075 L16.004672,8.04301075 C16.5543765,8.04301075 17,8.48863428 17,9.03833875 L17,20.2949946 C17,20.8446991 16.5543765,21.2903226 16.004672,21.2903226 L0.995328,21.2903226 C0.445623525,21.2903226 0,20.8446991 0,20.2949946 L0,9.03833875 C0,8.48863428 0.445623525,8.04301075 0.995328,8.04301075 Z M7.19230769,14.5001962 L7.19230769,16.8402007 C7.19230769,17.5559618 7.77254666,18.1362007 8.48830769,18.1362007 L8.51169231,18.1362007 C9.22745334,18.1362007 9.80769231,17.5559618 9.80769231,16.8402007 L9.80769231,14.5001962 C10.20899,14.1536714 10.4615385,13.6500931 10.4615385,13.0896057 C10.4615385,12.0444217 9.58332778,11.1971326 8.5,11.1971326 C7.41667222,11.1971326 6.53846154,12.0444217 6.53846154,13.0896057 C6.53846154,13.6500931 6.79101003,14.1536714 7.19230769,14.5001962 Z"
            id="Combined-Shape-lock"
          />
        </g>
      </g>
    </svg>
  )
}

export default Lock
